<template>
  <div>
    <p class="text-primary" style="margin-bottom: 20px">
      Configura el mensaje para el envío de documentos a tus clientes. Si se
      mantiene los campos vacíos se enviarán las plantillas por defecto de
      Mydessk.
    </p>

    <label class="msg-section-label">
      Mensaje para envío de documentos (por defecto)
    </label>

    <EditorWysiwygComponent
      @onEditorChange="onEditorChange"
      :setText.sync="userConfigText.message"
    />

    <!-- Global Additional Specifications -->
    <div class="msg-specs-section">
      <div class="msg-specs-header">
        <label class="msg-section-label mb-0">
          Especificaciones adicionales (globales)
        </label>
        <button
          type="button"
          class="msg-specs-add"
          @click="addSpec"
          title="Agregar especificación"
        >
          <i class="el-icon-plus"></i>
        </button>
      </div>
      <p class="msg-specs-hint">
        Estas especificaciones se agregarán automáticamente a cada nueva
        cotización.
      </p>

      <div
        v-for="(spec, index) in specifications"
        :key="index"
        class="msg-spec-row"
      >
        <el-input
          :value="spec"
          @input="updateSpec(index, $event)"
          placeholder="Escriba el detalle"
          size="small"
        ></el-input>
        <button
          type="button"
          class="msg-spec-delete"
          @click="removeSpec(index)"
          title="Eliminar"
        >
          <i class="el-icon-delete"></i>
        </button>
      </div>

      <p v-if="!specifications.length" class="msg-specs-empty">
        No hay especificaciones globales configuradas.
      </p>
    </div>

    <div class="mt-4">
      <button
        type="button"
        class="btn md__btn-primary"
        @click="handleSaveClick"
      >
        Guardar
      </button>
    </div>
  </div>
</template>

<script>
import configService from "../../services/configService";
import EditorWysiwygComponent from "../../../components/EditorWysiwyg";

export default {
  name: "PreferencesMessagesComponent",
  data: () => ({
    userConfigText: {},
    specifications: []
  }),
  methods: {
    async handleGetUserConfigTexts() {
      this.$store.dispatch("toggleRequestLoading");
      try {
        const businessId = this.$store.getters.getUser?.user_business?.id;
        let response = await configService
          .getUserConfigTexts(businessId)
          .finally(() => {
            this.$store.dispatch("toggleRequestLoading");
          });
        if (response.data.data) {
          this.userConfigText = response.data.data;
          this.specifications =
            response.data.data.additional_specifications || [];
        }
      } catch (error) {
        return false;
      }
    },
    onEditorChange({ text }) {
      this.userConfigText.message = text;
    },
    updateSpec(index, value) {
      this.$set(this.specifications, index, value);
    },
    addSpec() {
      this.specifications.push("");
    },
    removeSpec(index) {
      this.specifications.splice(index, 1);
    },
    async handleSaveClick() {
      this.$store.dispatch("toggleRequestLoading");
      try {
        const businessId = this.$store.getters.getUser?.user_business?.id;
        let response = await configService
          .updateUserConfigTexts(
            {
              ...this.userConfigText,
              additional_specifications: this.specifications.filter(
                s => s && s.trim()
              )
            },
            businessId
          )
          .finally(() => {
            this.$store.dispatch("toggleRequestLoading");
          });
        const { success, message, data } = response.data;
        if (success) {
          if (data) {
            this.userConfigText = data;
            this.specifications = data.additional_specifications || [];
          }
          this.$notifications.success({ message });
        }
      } catch (error) {
        this.$notifications.error({
          message: "No se pudo guardar la configuración"
        });
      }
    }
  },
  components: {
    EditorWysiwygComponent
  },
  mounted() {
    this.handleGetUserConfigTexts();
  }
};
</script>

<style lang="scss" scoped>
.msg-section-label {
  display: block;
  font-weight: 700;
  font-size: 14px;
  color: #31355c;
  margin-bottom: 12px;
  margin-top: 8px;
}

.msg-specs-section {
  margin-top: 28px;
  padding-top: 24px;
  border-top: 1px solid #e8ecf1;
}

.msg-specs-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
}

.msg-specs-add {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: none;
  background: #3ecfb4;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s;
  &:hover {
    background: #1d9e75;
  }
}

.msg-specs-hint {
  font-size: 12px;
  color: #909399;
  margin: 0 0 14px;
}

.msg-spec-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.msg-spec-delete {
  width: 30px;
  height: 30px;
  min-width: 30px;
  border: none;
  background: transparent;
  color: #f56c6c;
  font-size: 16px;
  cursor: pointer;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.12s;
  &:hover {
    background: #fff0f0;
  }
}

.msg-specs-empty {
  font-size: 13px;
  color: #c0c4cc;
  font-style: italic;
  margin: 0;
}
</style>

<style>
#pane-messages .quillWrapper {
  margin-top: 0 !important;
}
</style>
